import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import AssignmentSearchParams from '../AssignmentSearchParams';

export default class OrphanedAssignmentSearchParams extends SearchParamsBase {
  initialize() {
    this.SelectedCountryCodes = [];
    this.SelectedStatuses = [];
    this.SelectedOwningOfficeIds = [];
    this.SurveyNameOrId = '';
    this.ProjectNameOrId = '';
    this.ClientNameOrId = '';
    this.SelectedPaymentOfficeIds = [];
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedCountryCodes',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedStatuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: AssignmentSearchParams.getStatusValues(),
    },
    {
      fieldName: 'SelectedOwningOfficeIds',
      label: 'Owning Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedPaymentOfficeIds',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'ClientNameOrId',
      label: 'Client (Name or Bravo ID or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ProjectNameOrId',
      label: 'Project (Name or Bravo ID)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'SurveyNameOrId',
      label: 'Survey (Name or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
  ];

  static iconName = 'fas fa-search';
  static saveType = 'OrphanedAssignmentSearchParams';
}
